export default {
  mutateCommonObj (state, payload) {
    state.commonObj = Object.assign({}, state.commonObj, payload)
  },
  localizeCommonDropdown (state, payload) {
    state.commonObj.serviceTypeList = state.commonObj.serviceTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.subServiceTypeList = state.commonObj.subServiceTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.patientTypeList = state.commonObj.patientTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.bankInfoList = state.commonObj.bankInfoList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.branchInfoList = state.commonObj.branchInfoList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.hospitalInfoList = state.commonObj.hospitalInfoList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.hospitalThirtyPercentList = state.commonObj.hospitalThirtyPercentList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.serviceInfoList = state.commonObj.serviceInfoList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.deptList = state.commonObj.deptList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.consultancyReportTypeList = state.commonObj.consultancyReportTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.hosAssignDepartmentList = state.commonObj.hosAssignDepartmentList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.hosItemList = state.commonObj.hosItemList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.disabilityTypesList = state.commonObj.disabilityTypesList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.centerTypeList = state.commonObj.centerTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.subCenterList = state.commonObj.subCenterList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    // state.commonObj.itemCatList = state.commonObj.itemCatList.map(item => {
    //   const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
    //   return Object.assign({}, item, tmp)
    // })
    state.commonObj.hosItemStockList = state.commonObj.hosItemStockList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.masterServiceInfoList = state.commonObj.masterServiceInfoList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    // state.commonObj.hosItemList = state.commonObj.hosItemList.map(item => {
    //   const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
    //   return Object.assign({}, item, tmp)
    // })
    state.commonObj.itemCategoryList = state.commonObj.itemCategoryList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.hosWardList = state.commonObj.hosWardList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.hosBedList = state.commonObj.hosBedList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.identityTypeList = state.commonObj.identityTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.reportDurationList = state.commonObj.reportDurationList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.progressReportTypeList = state.commonObj.progressReportTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.therapyCenterList = state.commonObj.therapyCenterList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.campaignCenterList = state.commonObj.campaignCenterList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.campaignList = state.commonObj.campaignList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.therapyCentersList = state.commonObj.therapyCentersList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.campaignDesignationList = state.commonObj.campaignDesignationList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.assistiveDeviceList = state.commonObj.assistiveDeviceList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.ccList = state.commonObj.ccList.map(item => {
        const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
        return Object.assign({}, item, tmp)
    })
    state.commonObj.hpcList = state.commonObj.hpcList.map(item => {
        const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
        return Object.assign({}, item, tmp)
    })
    state.commonObj.rxList = state.commonObj.rxList.map(item => {
        const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
        return Object.assign({}, item, tmp)
    })
    state.commonObj.dhList = state.commonObj.dhList.map(item => {
        const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
        return Object.assign({}, item, tmp)
    })
    state.commonObj.oeList = state.commonObj.oeList.map(item => {
        const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
        return Object.assign({}, item, tmp)
    })
    state.commonObj.pmhList = state.commonObj.pmhList.map(item => {
        const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
        return Object.assign({}, item, tmp)
    })
    state.commonObj.adviceList = state.commonObj.adviceList.map(item => {
        const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
        return Object.assign({}, item, tmp)
    })
    state.commonObj.therapyServiceList = state.commonObj.therapyServiceList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.patientList = state.commonObj.patientList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.driverList = state.commonObj.driverList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.dcpoolList = state.commonObj.dcpoolList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.vanInfoList = state.commonObj.vanInfoList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.vanConditionlist = state.commonObj.vanConditionlist.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.equipmentTypeList = state.commonObj.equipmentTypeList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.reasonList = state.commonObj.reasonList.map(item => {
      const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
      return Object.assign({}, item, tmp)
    })
  }
}
